import React from 'react';
import { useFilterContext } from '../../context/aptmetrix/FilterContext';
import { useTooltip } from './useTooltip';
import FilterButton from './FilterButton';
import TooltipShell, { FilterActions } from './TooltipShell';

const SubwayFilter = ({ isOpen, onToggle, onClose, selectedRegion, data, onFilterChange }) => {
    const {
        filterUIState,
        setFilterUIState,
        filterComponentState,
        setSubwayFilter,
    } = useFilterContext();

    const { selectedSubwayLines, maxWalkingTime, isSubwayFilterActive } = filterUIState;
    const { subwayLines } = filterComponentState;

    const { tooltipRef, buttonRef } = useTooltip(isOpen, onClose);

    const updateUI = (updates) => setFilterUIState(prev => ({ ...prev, ...updates }));

    const handleToggle = () => {
        if (!selectedRegion) {
            alert('지역을 먼저 선택하세요');
            return;
        }
        onToggle();
    };

    const handleLineChange = (lineName) => {
        const newSelected = selectedSubwayLines.includes(lineName)
            ? selectedSubwayLines.filter(item => item !== lineName)
            : [...selectedSubwayLines, lineName];
        updateUI({ selectedSubwayLines: newSelected });
    };

    const handleSelectAll = (selectAll) => {
        updateUI({
            selectedSubwayLines: selectAll ? subwayLines.map(item => item.name) : [],
        });
    };

    const apply = () => {
        const isActive = selectedSubwayLines.length > 0;
        updateUI({ isSubwayFilterActive: isActive });
        const filterValue = {
            lines: isActive ? selectedSubwayLines : null,
            maxWalkingTime,
        };
        setSubwayFilter(filterValue);
        onFilterChange(filterValue);
        onClose();
    };

    const reset = () => {
        updateUI({ selectedSubwayLines: [], isSubwayFilterActive: false });
        if (maxWalkingTime !== null) {
            onFilterChange({ lines: null, maxWalkingTime });
        } else {
            onFilterChange(null);
        }
        onClose();
    };

    const isDisabled = !data || data.length === 0;

    return (
        <div className="relative">
            <FilterButton
                ref={buttonRef}
                label="지하철노선"
                activeLabel={`노선(${selectedSubwayLines.length})`}
                isActive={isSubwayFilterActive}
                isDisabled={isDisabled}
                onClick={handleToggle}
            />
            {isOpen && (
                <TooltipShell ref={tooltipRef} title="지하철 노선 필터 설정" onClose={onClose} className="right-0">
                    <div className="flex items-center justify-between mb-2 text-sm">
                        <button
                            onClick={() => handleSelectAll(true)}
                            className="px-2 py-1 text-xs bg-blue-50 hover:bg-blue-100 text-blue-700 rounded"
                        >
                            전체 선택
                        </button>
                        <button
                            onClick={() => handleSelectAll(false)}
                            className="px-2 py-1 text-xs bg-gray-50 hover:bg-gray-100 text-gray-700 rounded"
                        >
                            전체 해제
                        </button>
                    </div>
                    <div className="max-h-60 overflow-y-auto mb-3 border border-gray-100 rounded p-1">
                        {subwayLines.length > 0 ? (
                            subwayLines.map((lineInfo) => (
                                <div key={lineInfo.name} className="flex items-center mb-2">
                                    <input
                                        type="checkbox"
                                        id={`subway-line-${lineInfo.name}`}
                                        checked={selectedSubwayLines.includes(lineInfo.name)}
                                        onChange={() => handleLineChange(lineInfo.name)}
                                        className="mr-2"
                                    />
                                    <label htmlFor={`subway-line-${lineInfo.name}`} className="text-sm flex items-center">
                                        <span
                                            className="inline-block w-4 h-4 rounded-full mr-2"
                                            style={{ backgroundColor: lineInfo.color }}
                                        ></span>
                                        <span className="flex-grow">{lineInfo.name}</span>
                                        <span className="text-xs text-gray-500 ml-2">
                                            ({lineInfo.stations.length}개 역)
                                        </span>
                                    </label>
                                </div>
                            ))
                        ) : (
                            <div className="text-sm text-gray-500 p-2">지하철 정보가 없습니다.</div>
                        )}
                    </div>
                    <FilterActions onReset={reset} onApply={apply} />
                </TooltipShell>
            )}
        </div>
    );
};

export default SubwayFilter;
